import { WatchlistStoreData } from '../watchlist-store-data';
import { Action, ActionReducer } from '@ngrx/store';
import { WatchListActions } from '../actions/WatchListActions';
import { WatchlistIotActions } from '../actions/WatchlistIotActions';

export const watchlistStoreData: ActionReducer<any> = (
  state: WatchlistStoreData,
  action: Action
) => {
  switch (action.type) {
    case WatchListActions.LOAD_WATCHLIST:
      const newStateBeforeLoadWatchlist = Object.assign({}, state);
      if (!state.autoRefresh) {
        newStateBeforeLoadWatchlist.isLoading = true;
        newStateBeforeLoadWatchlist.vehicles = [];
        newStateBeforeLoadWatchlist.aggregations = [];
      }
      return newStateBeforeLoadWatchlist;

    case WatchListActions.LOAD_WATCHLIST_SUCCESS:
      return {
        vehicles: action.payload.vehicles,
        aggregations: action.payload.metadata.aggregations,
        total:
          Number.parseInt(action.payload.total, 10) > 100
            ? 100
            : Number.parseInt(action.payload.total, 10),
        autoRefresh: false
      };

    case WatchListActions.LOAD_WATCHLIST_FAILED:
      return {
        error: action.payload,
        vehicles: [],
        autoRefresh: false
      };

    case WatchListActions.REMOVE_VEHICLE_SUCCESS:
      const newStateAfterRemoveSuccess = Object.assign({}, state);
      newStateAfterRemoveSuccess.autoRefresh = true;
      return newStateAfterRemoveSuccess;

    case WatchListActions.UPDATE_VEHICLE_NOTE_SUCCESS:
      const newStateAfterUpdateNote = Object.assign({}, state);
      newStateAfterUpdateNote.vehicles.map(vehicle => {
        if (vehicle.nwVehicleId === action.payload.nwVehicleId) {
          action.payload.note
            ? (vehicle.note = action.payload.note)
            : delete vehicle['note'];
        }
      });
      return newStateAfterUpdateNote;

    /* Passive Events */

    case WatchlistIotActions.BID_INFO_UPDATED: {
      const newState = { ...state };
      const data = Object.keys(action.payload).reduce(
        (acc, key) =>
          action.payload[key] === null
            ? acc
            : { ...acc, [key]: action.payload[key] },
        {}
      );

      newState.vehicles = newState.vehicles.map(
        vehicle =>
          vehicle.nwVehicleId === action.payload.nwVehicleId
            ? { ...vehicle, ...data }
            : vehicle
      );

      return newState;
    }

    case WatchlistIotActions.VEHICLE_UPDATED:
      const newStateAfterModifiedVehicles = Object.assign({}, state);
      newStateAfterModifiedVehicles.vehicles = newStateAfterModifiedVehicles.vehicles.map(
        vehicle =>
          vehicle.nwVehicleId === action.payload.vehicle.nwVehicleId
            ? { ...vehicle, ...action.payload.vehicle }
            : vehicle
      );
      return newStateAfterModifiedVehicles;

    case WatchlistIotActions.VEHICLE_REMOVED:
      const newStateAfterRemovedVehicles = Object.assign({}, state);
      newStateAfterRemovedVehicles.vehicles.map(vehicle => {
        if (vehicle.nwVehicleId === action.payload.nwVehicleId) {
          vehicle.saleEventStates = action.payload.saleEventStates;
        }
      });
      return newStateAfterRemovedVehicles;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/reducers/watchlistStoreDataReducer.ts